const SAVES = [
    {
        slotId: 1,
        slotName: ""
    },
    {
        slotId: 2,
        slotName: ""
    },
    {
        slotId: 3,
        slotName: ""
    }
]

export default SAVES;